import React, { useState } from 'react';
import { Control, useWatch } from 'react-hook-form';
import { IImageDto } from '../../../utils/types';
import TextItem from '../../../ui/TextItem/textItem';
import i18n from '../../../utils/i18n';
import Button from '../../../ui/Button';
import { ButtonVariationEnum } from '../../../ui/Button/types';
import Popup from '../../../ui/Popup';
import GridRow from '../../../ui/GridRow';
import GridCol from '../../../ui/GridCol';
import { getProductImgSrc } from '../../../utils/url';
import ImagesUpload from '../../ImagesUpload';
import { FileUploadType } from '../../ImagesUpload/types';
import { PopupSize } from '../../../ui/Popup/Popup';
import { filesNames } from '../../../utils/fetch/filesNames';

interface IPriceImg {
    control: Control;
    name: string;
}

const PriceImg = ({ control, name }: IPriceImg) => {
    const [isPopupOpen, togglePopup] = useState<boolean>(false);

    const brand = useWatch({ name: 'brand', control });
    const productName = useWatch({ name: 'name', control });
    const images = useWatch({ name: name + '.priceImageEntityList', control });

    return (
        <div>
            <GridRow column gutter={8}>
                <TextItem label={i18n.general.images}>
                    <GridRow gutter={4}>
                        {images?.length
                            ? images.map((img: IImageDto) => {
                                  return (
                                      <GridCol col={4}>
                                          <img src={getProductImgSrc(img.src)} />
                                      </GridCol>
                                  );
                              })
                            : '-'}
                    </GridRow>
                </TextItem>
                <Button
                    variation={ButtonVariationEnum.SOFT}
                    isSmall
                    onClick={() => {
                        togglePopup(true);
                    }}
                >
                    {i18n.price.priceImageUpdate}
                </Button>
            </GridRow>
            {isPopupOpen && (
                <Popup
                    size={PopupSize.m}
                    title={i18n.price.priceImageUpdate}
                    close={() => {
                        togglePopup(false);
                    }}
                >
                    <ImagesUpload
                        control={control}
                        defaultAlt={`Купить ${brand?.name} ${productName} в Омске`}
                        fileName={filesNames({ brand: brand?.alias, name: productName })}
                        name={name + '.priceImageEntityList'}
                        type={FileUploadType.PRODUCT}
                        required={false}
                    />
                </Popup>
            )}
        </div>
    );
};

export default PriceImg;
